import {
  Container,
  styled,
} from "@mui/material";

const ContactUsPage = () => {
  const mailtoLink = (
    <a className="ContactUs-link" href="mailto:database@se2050.org">
      database@se2050.org
    </a>
  );

  return (
    <StyledContainer className="ContactUs">
      <div className="ContactUs-container">
        <h1 className="ContactUs-heading">
          Contact Support
        </h1>

        <p className="ContactUs-text">
          For further support or questions regarding the SE 2050 Database, email {mailtoLink}.
        </p>
      </div>
    </StyledContainer>
  );
};

export default ContactUsPage;

const StyledContainer = styled(Container)({
  maxWidth: '100%',
  width: '100%',
  height: '100%',
  marginTop: 20,
  marginBottom: 20,

  '& .ContactUs-container': {
    width: '100%',
    height: '100%',
    background: 'white',
    boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.12)',
    borderRadius: 5,
    paddingRight: 20,
    paddingLeft: 20,
    paddingTop: 1,
    marginTop: 20,
  }
});
